import axios from 'axios';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getStepData = ({shumaId, stepId}) => dispatch => {
  dispatch({
    type: A.GET_STEP_DATA,
  });

  const data = {
    shumaID: parseInt(shumaId, 10),
    stepID: parseInt(stepId, 10),
  };

  return axios.post(api.GET_STEP_DATA, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      dispatch({
        type: A.GET_STEP_DATA_SUCCESS,
        payload: transformData(body.stepData),
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_STEP_DATA_FAILURE,
        payload: err.message
      })
    });
};

const transformData = data => {
  const result = {};
  if (!data) return result;

  Object.keys(data).forEach(key => {
    const value = data[key];
    if (value === -1) {
      result[key] = '';
    } else {
      result[key] = value;
    }
  });

  return result;
};

